import {isNil} from 'ramda';

import type {AppSyncMessage} from '../types';
import {buildAuthHeader} from './buildAuthHeader';

const SUBSCRIPTION_QUERY = `
  subscription OnSendNotification {
    onSendNotification {
      id
      tenantId
      userId
      toastNotificationId
      backgroundNotificationId
    }
  }
`;

export const createSubscriptionMessage = (subscriptionId: string): AppSyncMessage | null => {
  const authHeader = buildAuthHeader();

  if (isNil(authHeader)) {
    console.error('Auth header is not found');
    return null;
  }

  return {
    id: subscriptionId,
    type: 'start',
    payload: {
      data: JSON.stringify({
        query: SUBSCRIPTION_QUERY,
        variables: {},
      }),
      extensions: {
        authorization: authHeader,
      },
    },
  };
};
